import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  availabilityButton: {
    marginLeft: theme.spacing(3),
    color: theme.palette.tertiary.darkGreen,
    '& svg': {
      height: '0.4em',
      fill: 'currentColor',
    },
    [theme.breakpoints.down(351)]: {
      marginLeft: theme.spacing(2),
      padding: `${theme.spacing(0.7)}px ${theme.spacing(1)}px`,
    },
  },
  link: {
    textDecoration: 'none',
  },
  bubble: {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: `translate(35%,-35%)`,
  },
}))

export default useStyles
